export const join = (first, ...rest) => {
	// we will send an empty string by default
	let path = first || '';

	// remove forward slash suffix
	if (path.length > 1 && path.substr(path.length - 1) === '/') {
		path = path.slice(0, -1);
	}

	// if there is only one parameter then return it as the path
	if (rest.length === 0) {
		return path;
	}

	// process the rest of the url parts
	let parts = rest
		.filter(part => typeof part === 'string')
		.map(part => part.replace(/^\/|\/$/, '')) // trim forward slashes
		.filter(part => part.length > 0); // remove empty strings

	// if after processing the parts there isn't anything to add then return
	if (parts.length === 0) {
		return path;
	}

	parts = parts.join('/');

	path += (path === '/' || path === '') ? parts : '/' + parts;

	return path;
};

export default {
	join,
};



// WEBPACK FOOTER //
// ../~/@jg/justgiving-app-login/app/router/path.js